<template lang="pug">
.card
  .card-body
    .row(v-if="$router.user.roleScore >= 2")
      .col-md-6
      .col-md-6
        .form-check
          input.mr-2(id="simulate" type="checkbox" v-model="simulateError") 
          label.text-danger Simulate Checkup Error
        .form-check
          input.mr-2(id="downgrade" type="checkbox" v-model="downgradeFirmware")
          label.text-danger Downgrade Firmware
    .row
      .col-12.col-md-6
        .card.card--device(:style="`border-left: 6px solid ${color};`")
          .card-body
            .d-flex.align-items-center.justify-content-between
              h6.mb-0.card-title Dispositivo
              button.btn.btn-sm.btn-primary(v-if="isSupported" @click="startTestPipeline" :disabled="isTesting") Inizia Collaudo
              .text.text-danger(v-else) Bluetooth is not supported on this device/browser.
            table.table.mt-2(v-if="device || isTesting")
              tr
                td Nome 
                td {{ deviceInfo.name }}
              tr
                td Firmware 
                td 
                  span {{ deviceInfo.firmware.version }} 
                  span(v-if="deviceInfo.firmware.latest") (Ultima: {{ deviceInfo.firmware.latest }})
              tr
                td  Check Up
                td 
                  span.badge.mx-1(
                    v-for="(value, key) in deviceInfo.checkup" 
                    :class="value ? 'badge-success' : 'badge-danger'"
                    :title="legend[key]"
                  ) {{ key }}
              tr(v-if="isShelfy")
                td Batteria
                td 
                  span.badge.mx-1(v-if="deviceInfo.battery.percentage" :class="deviceInfo.battery.percentage < 30 || deviceInfo.battery.percentage > 50  ? 'badge-warning' : 'badge-success'") {{ deviceInfo.battery.percentage }}%
                  span.mx-1 -
                  span(v-if="deviceInfo.battery.voltage") {{ deviceInfo.battery.voltage }} mV
              //- tr
              //-   td Comandi Led
              //-   td 
              //-     span.badge.mx-1(:class="deviceInfo.leds.output === null ? 'badge-secondary' : deviceInfo.leds.output ? 'badge-success' : 'badge-danger'") OUT
              //-     span.badge.mx-1(:class="deviceInfo.leds.internal === null ? 'badge-secondary' : deviceInfo.leds.internal ? 'badge-success' : 'badge-danger'") IN
              //- tr
              //-   td Comando Ventola
              //-   td 
              //-     span.badge.mx-1(:class="deviceInfo.fan === null ? 'badge-secondary' : deviceInfo.fan ? 'badge-success' : 'badge-danger'") {{ deviceInfo.fan === null ? '' : deviceInfo.fan ? 'OK' : 'NOT OK' }}
              tr(v-if="isShelfy")
                td Shipping Mode 
                td  
                  span.badge(:class="deviceInfo.shipping_mode === null ? 'badge-secondary' : deviceInfo.shipping_mode ? 'badge-success' : 'badge-secondary'") {{ deviceInfo.shipping_mode === null ? '' : deviceInfo.shipping_mode ? 'Activated' : 'Not Activated' }}
            .alert.alert-warning(v-if="needsReconnect")
              p.mb-1 Firmware aggiornato. Riconnetti il dispositivo per continuare il test.
              button.btn.btn-warning.btn-sm(@click="reconnectAndContinue") Riconnetti Dispositivo
            .alert.alert-danger(v-if="errorMessage") {{ errorMessage }}
            button.btn.btn-sm.btn-danger(v-if="isTesting" @click="resetTest" :disabled="!isTesting") 
              i.fa.fa-stop-circle.mr-2
              span Arresta Collaudo
      .col-12.col-md-6
        .steps 
          template(v-for="(step, index) in steps")
            .step(:class="step.status" v-if="!device || step.products.includes(deviceInfo.name.substr(0,3))")
              .d-flex.align-items-center
                .step__status
                  template(v-if="step.status === 'to-do'") {{ index + 1 }}
                  i.fa.fa-spinner.spinner(v-if="step.status === 'in-progress'")
                  i.fa.fa-check(v-if="step.status === 'passed'")
                  i.fa.fa-times(v-if="step.status === 'failed'")
                  i.fa.fa-forward(v-if="step.status === 'skipped'")
                div
                  .step__name {{ step.name }}
                  small.step__description {{ step.description }}
              .step_substeps(v-if="step.substeps")
                .step.substep.d-flex(v-for="(substep, i) in step.substeps" :class="substep.status" v-if="substep.status !== 'to-do'")
                  .step__status
                    template(v-if="substep.status === 'to-do'") {{ index + 1 }}.{{ i + 1 }}
                    i.fa.fa-spinner.spinner(v-if="substep.status === 'in-progress'")
                    i.fa.fa-check(v-if="substep.status === 'passed'")
                    i.fa.fa-times(v-if="substep.status === 'failed'")
                    i.fa.fa-forward(v-if="substep.status === 'skipped'")
                  .step__name {{ substep.name }}
        .mt-1(v-if="isTestCompleted || isTestFailed")
          template(v-if="this.deviceInfo.checkup.result")
            button.btn-block.btn.btn-success.mb-1(:disabled="isSaving" @click="endTest(false)") Tutto ok
            ReportNC(v-if="order" :order="order" 
              :mac="deviceInfo.mac" :disabled="isSaving" 
              @ncReported="endTest"
            ) (Manual)
          ReportNC(v-else="order" :order="order" 
            :mac="deviceInfo.mac" :disabled="isSaving" 
            :autoReasonIds="failedTestReasonId"
            @ncReported="endTest"
          ) (Auto)
</template>
<script>

import {BleService, DeviceType, SMGHMLedOutMode, SMGHMWifiConnectionMode, SMGHMWifiSecurityMethod} from "@vitesy/vhub-browser-ble";

const CONFIG = {
  serviceUUID: 'c954c6e6-3016-4416-a72f-b184a4f039e0',
  characteristicUUID: '2b3247fd-28db-413c-934f-aa4c271984c9',
  WiFiCredentials: {
    //SSID: 'MW40V_DA06',
    //Password: '98541014',
    //SSID: 'TAG PN Wifi',
    //Password: 'tagpnrocks15',
    SSID: "Vodafone-C00630005",
    Password: "k3mR2XXAtxC4AC4K",
    // SSID: "Tdp the best",
    // Password: "Balena54!",
    //Method: '2',
    SecurityMethod: SMGHMWifiSecurityMethod.WPA2_PSK
  },
  latestFirmwareVersion: '0.0.14',
  firmwaresURL: 'https://static.vitesyhub.com/firmwares/'
}

const COLORS = {
  red: [0xFF, 0x00, 0x00],
  green: [0x00, 0xFF, 0x00],
  blue: [0x00, 0x00, 0xFF],
  purple: [0xFF, 0x00, 0xFF],
  yellow: [0xFF, 0xFF, 0x00],
  orange: [0xFF, 0xA5, 0x00],
  cyan: [0x00, 0xFF, 0xFF]
}

const STATUS = {
  TO_DO: "to-do",
  IN_PROGRESS: "in-progress",
  PASSED: "passed",
  FAILED: "failed",
  SKIPPED: "skipped",
}

import ProductionService from "@/services/ProductionService";
import ReportNC from "./ReportNC";

export default {
  name: 'SingleDeviceTesting2',
  props: ['color'],
  data() {
    return {
      order: null,
      simulateError: false, // TEMP
      downgradeFirmware: false, // TEMP
      needsReconnect: false,
      activeDevice: null,
      isSupported: false,
      isConnected: false,
      attempt: 0,
      isTesting: false,
      isTestCompleted: false,
      isTestFailed: false,
      isSaving: false,
      device: null,
      server: null,
      characteristic: null,
      deviceInfo: {},
      failedTestReasonId: null,
      errorMessage: null,
      gattOperationInProgress: false,
      steps: [
        {
          name: 'Connessione al Dispositivo',
          status: STATUS.TO_DO,
          products: ['SLF','SMG','Sme']
        },
        {
          name: 'Controllo Versione Firmware',
          status: STATUS.TO_DO,
          products: ['SLF','SMG','Sme'],
          substeps: [
            {
              name: 'Connessione al Wi-Fi',
              status: STATUS.TO_DO,
            },
            {
              name: 'Aggiornamento Firmware',
              status: STATUS.TO_DO,
            },
          ]
        },
        {
          name: 'Check Up Automatico',
          status: STATUS.TO_DO,
          products: ['SLF','SMG','Sme']
        },
        {
          name: 'Controllo Manuale',
          description: 'Percentuale carica batteria, led e ventola accesi, difetti estetici.',
          status: STATUS.TO_DO,
          products: ['SLF','SMG','Sme']
        },
        {
          name: 'Collaudo Completato',
          status: STATUS.TO_DO,
          products: ['SLF','SMG','Sme']
        }
      ],
      legend: {
        CHG: "Battery Charger",
        SHT4x: "Sensore Temperatura/Umidità",
        LIS2DH12: "Accelerometro",
        LPS22HH: "Sensore Pressione/Temperatura",
        BME680: "Sensore Gas",
        ESP32: "Modulo Wi-Fi/BLE",
        BLE: "Bluetooth",
        VoC: "Sensore VoC",
        HUM: "Sensore Umidità"
      }
    };
  },
  computed: {
    isShelfy(){
      return this.deviceInfo?.name?.startsWith('SLF')
    },
    isSmeg(){
      return this.deviceInfo?.name?.startsWith('SMGHM') || this.deviceInfo?.name?.startsWith('SmegAria')
    },
  },
  components: { ReportNC },
  methods: {
    wait(ms) {
      return new Promise(resolve => setTimeout(resolve, ms) )
    },
    async resetTest(){
      this.device ? this.device.removeEventListener('gattserverdisconnected', async () => { await this.handleDeviceDisconnection() }) : ''
      if (this.server?.connected) {
        await this.characteristic?.stopNotifications()
        await this.server.disconnect()
      }

      // A failed pipeline never reaches endTest()'s cleanup, so a retry here
      // would otherwise overwrite this.activeDevice and leak its still-open
      // GATT connection — the adapter's connection slots fill up over a
      // session of retries until even one device stops connecting reliably.
      if (this.activeDevice) {
        try { await this.activeDevice.disconnect() } catch(e) { console.warn('Disconnect failed:', e) }
        this.activeDevice = null
      }

      this.device = null
      this.server = null
      this.characteristic = null
      this.isTesting = false
      this.isTestCompleted = false
      this.isTestFailed = false
      this.errorMessage = null

      this.steps.forEach(step => {
        step.status = "to-do"
        if (step.substeps) {
          step.substeps.forEach(substep => {
            substep.status = "to-do"
          })
        }
      })

      this.deviceInfo = {
        name: '',
        mac: '',
        firmware: {
          version: '-',
          latest: null,
          updated: false
        },
        battery: {
          percentage: '',
          voltage: ''
        },
        leds: {
          output: null,
          internal: null
        },
        fan: null,
        checkup: {},
        shipping_mode: null,
        start_timestamp: null
      }
    },
    async connectToDevice() {
      this.steps[0].status = STATUS.IN_PROGRESS
      let device = null
      try {
        device = await BleService.requestDevice([DeviceType.SMGHM, DeviceType.SMGHM_LEGACY])

        this.deviceInfo.name = device.name
        this.deviceInfo.mac = device.id.replace(/:/g, '')

        await device.connect()
        this.steps[0].status = STATUS.PASSED

        return device
      } catch (e) {
        console.error(e)
        this.steps[0].status = STATUS.FAILED
        // connect() can fail with the GATT link already open (e.g. it got as
        // far as startNotifications). A connected device stops advertising, so
        // leaving it behind makes it vanish from the BLE picker until the
        // browser is restarted — always hang up before giving up.
        if (device) {
          try { await device.disconnect() } catch(err) { console.warn('Disconnect failed:', err) }
        }
        // Returning undefined here used to let the pipeline carry on and blow
        // up later with "Cannot read properties of undefined", hiding the real
        // connection error. Fail loudly at the point of failure instead.
        throw e
      }
    },
    compareVersions(a, b) {
        const a_ = a.split('.').map(x => +x)
        const b_ = b.split('.').map(x => +x)

        a_.push(0, 0, 0)
        b_.push(0, 0, 0)

        for (let i = 0; i < 3; i++) {
          if (a_[i] < b_[i]) {
            return 1
          } else if (a_[i] > b_[i]) {
            return -1
          }
        }
        return 0
    },
    async checkFirmwareVersion(device){
      this.steps[1].status = STATUS.IN_PROGRESS
      try {
        const { firmwareVersion } = await device.getFirmwareVersion()
        this.deviceInfo.firmware.version = firmwareVersion

        const shouldUpdate = this.compareVersions(firmwareVersion, CONFIG.latestFirmwareVersion) > 0
        if (shouldUpdate) {
          await this.updateFirmware(device, firmwareVersion, CONFIG.latestFirmwareVersion)
        }
        this.steps[1].status = STATUS.PASSED
      } catch (e) {
        console.error(e)
        this.steps[1].status = STATUS.FAILED
        // A failed firmware step must abort the pipeline — testing a device
        // that is still on old firmware produces meaningless results.
        throw e
      }
    },
    async updateFirmware(device, currentFirmwareVersion, latestFirmwareVersion) {
      this.steps[1].substeps[0].status = STATUS.IN_PROGRESS

      const supportsOTACommand = this.compareVersions(currentFirmwareVersion, '0.0.06') <= 0
      if (supportsOTACommand) {
        // WiFi OTA path (firmware >= 0.0.06)
        try {
          await this.connectToWifi(device, CONFIG.WiFiCredentials.SSID, CONFIG.WiFiCredentials.Password, CONFIG.WiFiCredentials.SecurityMethod)
          this.steps[1].substeps[0].status = STATUS.PASSED
        } catch (e) {
          console.error(e)
          this.steps[1].status = STATUS.FAILED
          this.steps[1].substeps[0].status = STATUS.FAILED
          this.failedTestReasonId = [2.1]
          this.sendError(`Unable to connect to Wi-Fi!`)
        }

        this.steps[1].substeps[1].status = STATUS.IN_PROGRESS
        try {
          await device.setOtaWifi(latestFirmwareVersion)

          // Wait for device to download, flash and reboot
          await this.wait(90000)

          // Reconnect with retries
          let reconnected = false
          for (let i = 0; i < 10 && !reconnected; i++) {
            try { reconnected = await device.connect() } catch(e) { await this.wait(15000) }
          }

          if (reconnected) {
            // Stabilize GATT after reboot
            await this.wait(3000)

            // Verify firmware version post-reboot (with retries)
            let newVersion = null
            for (let i = 0; i < 4 && !newVersion; i++) {
              try {
                const r = await device.getFirmwareVersion()
                newVersion = r.firmwareVersion
              } catch(e) { await this.wait(5000) }
            }
            if (newVersion) {
              if (this.compareVersions(newVersion, latestFirmwareVersion) > 0) {
                throw new Error(`Firmware still reports ${newVersion} after update (expected ${latestFirmwareVersion}) — update did not take effect`)
              }
              this.deviceInfo.firmware.version = newVersion
            }
          } else {
            // Web Bluetooth cannot reconnect post-WiFi-OTA — trust update succeeded, ask user to reconnect manually
            this.deviceInfo.firmware.version = latestFirmwareVersion
            this.needsReconnect = true
          }

          this.steps[1].substeps[1].status = STATUS.PASSED
        } catch (e) {
          console.error(e)
          this.steps[1].status = STATUS.FAILED
          this.steps[1].substeps[1].status = STATUS.FAILED
          this.failedTestReasonId = [2.2]
          this.sendError(e.message || 'OTA update failed')
        }
      } else {
        // BLE OTA path (legacy firmware < 0.0.06)
        this.steps[1].substeps[0].status = STATUS.SKIPPED
        this.steps[1].substeps[1].status = STATUS.IN_PROGRESS
        try {
          const response = await fetch(CONFIG.firmwaresURL + 'smghm/v' + latestFirmwareVersion + '.bin')
          const firmware = await response.arrayBuffer()

          // A device that comes back still on the old version now genuinely
          // means the image did not take: the library no longer restarts the
          // device while its bootloader is writing, which used to produce that
          // same symptom on a flash that was working. So a second attempt is a
          // real safety net rather than a way to interrupt a good flash.
          const FLASH_ATTEMPTS = 2
          let newVersion = null
          let lastError = null
          let deviceChangedIdentity = false

          for (let flash = 1; flash <= FLASH_ATTEMPTS && !newVersion && !deviceChangedIdentity; flash++) {
            console.log(`[${device.id}] firmware flash attempt ${flash}/${FLASH_ATTEMPTS}`)
            try {
              newVersion = await this.flashFirmwareOverBle(device, firmware, latestFirmwareVersion)
              // null means the device stopped answering on this connection after
              // the flash, which is what an accepted image looks like: the new
              // firmware advertises under a different BLE name, so this handle
              // can never reach it again. Reflashing would be wrong — it already
              // worked — but we cannot confirm the version without a new device
              // selection, and that needs a click.
              deviceChangedIdentity = newVersion === null
            } catch (e) {
              console.log(`[${device.id}] flash attempt ${flash}/${FLASH_ATTEMPTS} failed: ${e.message || e}`)
              lastError = e
            }
          }

          if (deviceChangedIdentity) {
            // Optimistic until reconnectAndContinue() actually reads it back.
            this.deviceInfo.firmware.version = latestFirmwareVersion
            this.needsReconnect = true
            this.steps[1].substeps[1].status = STATUS.PASSED
          } else {
            if (!newVersion) throw lastError

            this.deviceInfo.firmware.version = newVersion
            this.steps[1].substeps[1].status = STATUS.PASSED
          }
        } catch (e) {
          console.error(e)
          this.steps[1].status = STATUS.FAILED
          this.steps[1].substeps[1].status = STATUS.FAILED
          this.failedTestReasonId = [2.2]
          this.sendError('BLE firmware update failed')
        }
      }

      this.deviceInfo.firmware.updated = true
    },
    // Flashes the image over BLE. Returns the version the device reports, or
    // null when it stopped answering on this connection (an accepted image
    // changes the device's BLE name, so the handle we hold goes dead). Throws
    // when the device is still reachable but running the old firmware, which
    // means the image was rejected and reflashing is worth a try.
    async flashFirmwareOverBle(device, firmware, latestFirmwareVersion) {
      // The library owns the whole sequence — bootloader entry, transfer,
      // restart and the waits around both reboots. All that is left here is
      // the verdict: coming back alive does not mean the image was accepted,
      // only a version that actually advanced does.
      const newVersion = await device.updateFirmware(firmware)

      if (newVersion === null) {
        return null
      }

      if (this.compareVersions(newVersion, latestFirmwareVersion) > 0) {
        throw new Error(`Firmware still reports ${newVersion} after update (expected ${latestFirmwareVersion}) — update did not take effect`)
      }

      return newVersion
    },
    async connectToWifi(device, ssid, password, securityMethod) {
      await device.setReset()
      await device.setWifiSsid(ssid)
      await device.setWifiPsw(password)
      await device.setWifiConnect(SMGHMWifiConnectionMode.AUTO, securityMethod)

      // Wait for WiFi connection (max 45s)
      for (let i = 0; i < 15; i++) {
        await this.wait(3000)
        const connected = await device.isWifiConnected()
        if (connected) return
      }
      throw new Error('WiFi connection timeout')
    },
    async checkup(device){
      this.steps[2].status = STATUS.IN_PROGRESS

      try {
        const { esp32, voc, hum, ble } = await device.getCheckUp()
        console.log({ esp32, voc, hum, ble})

        const result = esp32 && voc && hum && ble
        this.deviceInfo.checkup.result = result

        if (!result) {
          throw new Error()
        }

        this.steps[2].status = STATUS.PASSED
      } catch (e) {
        this.steps[2].status = STATUS.FAILED
        this.failedTestReasonId = [4.0]
        this.sendError('Checkup failed!')
      }
    },
    async activateLedsAndFan(device) {
      try {
        await device.setLedIn(100)
        await device.setLedOut(SMGHMLedOutMode.ON, 255, 255, 255, 0)
        await device.setFan(100)
      } catch(e) {
        console.warn('LED/fan activation failed:', e)
      }
    },
    async deactivateLedsAndFan(device) {
      try {
        await device.setLedIn(0)
        await device.setLedOut(SMGHMLedOutMode.OFF, 0, 0, 0, 0)
        await device.setFan(0)
      } catch(e) {
        console.warn('LED/fan deactivation failed:', e)
      }
    },
    async reconnectAndContinue() {
      this.needsReconnect = false
      this.isTesting = true
      this.errorMessage = null
      try {
        const device = await BleService.requestDevice([DeviceType.SMGHM, DeviceType.SMGHM_LEGACY])
        await device.connect()
        this.activeDevice = device
        this.deviceInfo.name = device.name
        this.deviceInfo.mac = device.id.replace(/:/g, '')

        // This reconnect exists because the device changed identity after being
        // flashed, so it is the first chance to actually confirm the update —
        // everything before it was assumed. Check before testing further: a
        // device still on the old firmware makes the rest of the test worthless.
        const { firmwareVersion } = await device.getFirmwareVersion()
        this.deviceInfo.firmware.version = firmwareVersion
        if (this.compareVersions(firmwareVersion, CONFIG.latestFirmwareVersion) > 0) {
          this.steps[1].status = STATUS.FAILED
          this.steps[1].substeps[1].status = STATUS.FAILED
          this.failedTestReasonId = [2.2]
          this.sendError(`Firmware still reports ${firmwareVersion} after update (expected ${CONFIG.latestFirmwareVersion})`)
        }
        this.steps[1].status = STATUS.PASSED

        await this.checkup(device)
        await this.activateLedsAndFan(device)

        this.steps[3].status = STATUS.IN_PROGRESS
        this.isTestCompleted = true
      } catch(e) {
        this.errorMessage = e
        this.isTestFailed = true
        this.isTestCompleted = true
      } finally {
        this.isTesting = false
      }
    },
    sendError(error){
      throw new Error(error)
    },
    async startTestPipeline() {
      await this.resetTest()
      this.isTesting = true
      try {
        const device = await this.connectToDevice()
        this.activeDevice = device
        console.log({device})

        const response = await ProductionService.getProductionOrderByMac(this.deviceInfo.mac.toUpperCase())
        if (response && response.data) {
          this.order = response.data
        } else {
          alert('Dispositivo non trovato in nessun ordine di produzione.')
          this.order = null
        }

        this.deviceInfo.start_timestamp = new Date().getTime()

        await this.checkFirmwareVersion(device)

        if (this.needsReconnect) {
          // After WiFi OTA the BLE connection is lost — show reconnect button, wait for user gesture
          this.isTesting = false
          return
        }

        await this.checkup(device)
        await this.activateLedsAndFan(device)

        this.steps[3].status = STATUS.IN_PROGRESS
        this.isTestCompleted = true
      } catch (error) {
        this.errorMessage = error
        console.error('PIPELINE ERROR:', error)
        // await this.writeOutputLeds([...COLORS.red,...COLORS.red,...COLORS.red,...COLORS.red])
        this.isTestFailed = true
        this.isTestCompleted = true

        // A failed run used to keep its GATT link open until the operator
        // started the next test on this slot. Every failed slot therefore held
        // one of the adapter's few connection slots and kept its device from
        // advertising, so after a batch of failures even a single new test
        // could no longer connect. Release the device as soon as we give up.
        if (this.activeDevice) {
          try { await this.activeDevice.disconnect() } catch(e) { console.warn('Disconnect failed:', e) }
          this.activeDevice = null
        }
      }
    },
    async endTest(reportedNC) {

      if (reportedNC) {
        // await this.writeOutputLeds([...COLORS.red,...COLORS.red,...COLORS.red,...COLORS.red])
        if (reportedNC.error) {
        alert(`Errore durante segnalazione della non conformità: ${reportedNC.error}`)
        }
      }

      this.isSaving = true

      if (this.activeDevice) await this.deactivateLedsAndFan(this.activeDevice)

      this.steps[3].status = this.isTestFailed ? STATUS.SKIPPED : !reportedNC ? STATUS.PASSED : STATUS.FAILED

      await this.wait(1000)

      this.steps[4].status = STATUS.IN_PROGRESS
      if (this.activeDevice) {
        try { await this.activeDevice.setReset() } catch(e) { console.warn('Reset failed:', e) }
        try { await this.activeDevice.disconnect() } catch(e) { console.warn('Disconnect failed:', e) }
        this.activeDevice = null
      }
      await this.saveTestResponse(reportedNC)
      this.steps[4].status = STATUS.PASSED

      await this.wait(1000)
      this.isSaving = false
      await this.resetTest()
    },
    async saveTestResponse(reportedNC){
      // this.steps[6].status = STATUS.IN_PROGRESS

      const testLog = {
        id: this.deviceInfo.name,
        type: 'device',
        data: {
          id_number: this.order ? this.order.id_number : null,
          ...this.deviceInfo,
          end_timestamp: new Date().getTime(),
          nc: reportedNC
        }
      }
      const testResponse = await ProductionService.addProductionTest(testLog)
      console.log(testResponse, testLog)

      const response = true
      // this.steps[6].status = response ? STATUS.PASSED : STATUS.FAILED
    }

  },
  async mounted() {
    if ('bluetooth' in navigator) {
      this.isSupported = true
      window.addEventListener("keyup", (e) => {
        e.keyCode === 32 ? !this.isTesting ? this.startTestPipeline() : '' : ''
      })

      // const { data } = await ProductionService.getProductionOrder(this.id_number)
      // this.order = data

    } else {
      console.error('Bluetooth is not supported on this device/browser.');
      return;
    }
  },
};
</script>
<style lang="scss" scoped>
@import "../../styles/variables.scss";
.card {
  background-color: #b8d9f0;
}
.code {
  background-color: #2c2c2c;
  color: #B4D455;
}

.steps {
  position: relative;
  &:before {
    content: '';
    display: block;
    width: 2px;
    height: 100%;
    position: absolute;
    left: 1.25rem;
    top: 0;
    background-color: $lightblue;
  }
}
.step, .substep {
  position: relative;
  background-color: #fff;
  border: 1px solid $lightblue;
  border-radius: 2rem;
  padding: .25rem .25rem;
  margin: .5rem 0;
  align-items: center;

  &__description {
    line-height: 0;
  }

  &__status {
    background-color: $lightblue;
    width: 2rem;
    height: 2rem;
    border-radius: 100%;
    text-align: center;
    font-size: 1rem;
    line-height: 2rem;
    margin-right: .5rem;
    flex: 0 0 auto;
  }
  &.passed {
    .step__status {
      background-color: $green!important;
      animation: none!important;
      color: #fff;
    }
    border-color: $green;
  }
  &.failed {
    .step__status {
      background-color: $red;
      color: #fff;
    }
    border-color: $red;
  }
  &.skipped {
    .step__status {
      background-color: $gray01;
      color: $gray02;
    }
    border-color: $gray02;
  }
  &.to-do {
    opacity: .75;
  }
  &.in-progress {
    .step__status {
      @extend .rotate;
      background-color: $blue;
      color: #fff;
    }
    border-color: $blue;
  }
}
</style>
